import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { AuthService, RestServices, SharedServices } from '@app/services'

@Component({
    selector: 'app-broadcast-mail-history',
    templateUrl: './broadcast-mail-history.component.html',
    styleUrls: [
        '../../../../stagingcss/main-body.component.css',
        './broadcast-mail-history.component.css',
        '../../../../stagingcss/lui-select.component.css',
        '../../../top/top.component.css'],
})
export class BroadcastMailHistoryComponent implements OnInit {
    listBroadcastMail: any
    hiddenModal = 'hidden'
    en = {}
    showEN = true


    constructor(private authData: AuthService, private router: Router, private restApi: RestServices, private _sharedService: SharedServices) {
    }

    ngOnInit() {
        this.mainClient()
        $('ons-page').find('.ng-scrollbar').addClass('-vertical')
    }

    mainClient() {
        const resourceUrl = 'resource'
        const resourceData = {
            actions: [],
            status: {
                broadCastMail: {
                    paths: {
                        '{}': true,
                    },
                },
                clinic: {
                    paths: {
                        '{}': true,
                    },
                },
                client: {
                    paths: {
                        '{}': true,
                    },
                },
                setting: {
                    map: {
                        common: true,
                    },
                },
                staff: {
                    paths: {
                        '{"roles":"cordinator"}': true,
                        '{"roles":"doctor"}': true,
                        '{}': true,
                    },
                },
            },
        }
        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post(resourceUrl, resourceData, tokenReNew).subscribe(
                success => {
                    const mailFrom = success['response']['setting']['map']['common']['senderAddress']
                    const nameFrom = success['response']['setting']['map']['common']['senderName']
                    this.listBroadcastMail = success['response']['broadCastMail']['paths']['{}']
                    this.listBroadcastMail.map(item => {
                        item.mailFrom = mailFrom
                        return item.nameFrom = nameFrom
                    })
                },
            )
        }).catch(err => {
        })
    }

    changeLanguage() {
        return this.en = this.authData.showLang(this.showEN)
    }

    selectPreview(ClientMailDetail) {
        ClientMailDetail.modal = 'BroadcastMailPreview'
        this._sharedService.emitChange(ClientMailDetail)
    }

    openMailFailureList(broadCastMailItem) {
        broadCastMailItem.modal = 'BroadcastMailFailure'
        this._sharedService.emitChange(broadCastMailItem)
    }

}



// WEBPACK FOOTER //
// ./src/app/app_manager/app_element/status/broadcast-mail-history/broadcast-mail-history.component.ts